import React, { useState, useEffect, useMemo } from 'react';
import {
  getEventCisData,
  getFilterdByDate,
  // getAllUsersData,
  getTargetbyMonth,
  getAttachRate,
  getOnlyAccessory,
} from '../helper/helper';
import { removeDuplicatesByInvoice } from './ReusableFunctions';
import { ADMIN_ROLE, EMPLYEE_ROLE, MANAGER_ROLE } from './AdminDashboard/utils';

function DateFilter({
  combinedTargets,
  onDataLoaded,
  targetData,
  manualData,
  currentMonth,
  setLoadingCondition,
  AAMSRP,
  OAMSRP,
  accessoryListAR,
  accessoryListOA,
  onEventDataLoaded = () => {},
  // datesSelected,
  dataLoading = () => {},
  getDates = () => {},
  userList = []
}) {
  const userDetails = useMemo(() => JSON.parse(localStorage.getItem('user_data')), []);

  const currentDate = new Date();
  const currentDateString = currentDate.toISOString().split('T')[0];
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  // const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const firstDayOfMonthString = firstDayOfMonth.toISOString().split('T')[0];
  // const lastDayOfMonthString = lastDayOfMonth.toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(firstDayOfMonthString);
  const [endDate, setEndDate] = useState(currentDateString);
  // const endOfYear = new Date(currentDate.getFullYear(), 11, 31);
  // const endOfYearString = endOfYear.toISOString().split('T')[0]; // Format: 'YYYY-MM-DD'

  /* const [userDetail, setUserDetail] = useState(null); */
  // const [userList, setuserList] = useState([]);

  // const username = localStorage.getItem('username');

  // useEffect(() => {
  //   async function fetchUser() {
  //     let { data } = await getAllUsersData();
  //     setuserList(data);
  //   }
  //   fetchUser();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [username]);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    getDates({ startDate, endDate });

    async function getRawCisData() {
      setLoadingCondition(true);
      dataLoading(true);
      // Resetting these values on every fetch. so user sees change in amount
      OAMSRP([]);
      AAMSRP([]);
      targetData([]);
      onDataLoaded([]);
      try {
        let { data } = await getFilterdByDate({ startDate, endDate, signal });
        onDataLoaded(data);

        // If end date is 1st of any month, target is fetch for previous month
        const dateObj = new Date(endDate);
        const options = { month: 'long' };
        const yearOptions = { year: 'numeric' };
        const monthName = new Intl.DateTimeFormat('en-US', options).format(dateObj);
        const yearName = new Intl.DateTimeFormat('en-US', yearOptions).format(dateObj);

        if (monthName !== '' && yearName !== '') {
          getTargetbyMonth({
            selectedMonth: monthName,
            currentYear: yearName,
            signal,
          }).then((res) => {
            targetData(res.data || [], { startDate, endDate });
            currentMonth([monthName, yearName]);
            // datesSelected({ startDate, endDate });
          });
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Fetch error:', error);
        }
      } finally {
        if (!signal.aborted) {
          setLoadingCondition(false);
          dataLoading(false);
        }
      }

      try {
        let { data } = await getEventCisData({ startDate, endDate, signal });
        onEventDataLoaded(data || []);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Fetch error:', error);
        }
      }
    }

    getRawCisData();

    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);


  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    async function fetchData() {
      try {
        const [userResponse, arDataResponse] = await Promise.all([
          getOnlyAccessory({ startDate, endDate, signal }),
          getAttachRate({ startDate, endDate, signal }),
        ]);

        const userData = userResponse.data;
        const arData = arDataResponse.data;
        // Process userData
        let filtered = [];
        userData.forEach((obj) => {
          filtered.push(obj.attachmentRateOnlyAccessory);
        });
        const uniqueUserArray = removeDuplicatesByInvoice(filtered, 'saleInvoiceOA');
        processUserData(uniqueUserArray);
        // Process arData
        if (arData) {
          const uniqueARArray = removeDuplicatesByInvoice(arData);
          processARData(uniqueARArray);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Fetch error:', error);
        }
      }
    }

    function processUserData(uniqueArray) {
      if (uniqueArray.length > 0) {
        if (userDetails?.role === MANAGER_ROLE) {
          let storesList = userDetails?.stores?.split(',');
          let matchingInvoices = uniqueArray.filter((item) => {
            let prefix = '';
            if (item.saleInvoiceOA !== '') {
              // Was causing accessory mismatch for manager, OA was not getting included
              prefix = item?.storeInvoiceOA;
            }
            return storesList.some((prefixInArray) => prefix === prefixInArray);
          });
          dataProcessOA(matchingInvoices);
        } else if (userDetails?.role === ADMIN_ROLE) {
          dataProcessOA(uniqueArray);
        } else if (userDetails?.role === EMPLYEE_ROLE) {
          let filterAR = [];
          uniqueArray.forEach((obj) => {
            if (obj.username === userDetails?.username) {
              filterAR.push(obj);
            }
          });
          dataProcessOA(filterAR);
        }
      }
    }

    function processARData(uniqueArray) {
      if (uniqueArray?.length > 0) {
        if (userDetails?.role === 'manager') {
          let finalArray = [];
          userDetails?.stores?.split(',').forEach((store) => {
            userList.forEach((user) => {
              let exist = user.stores.split(',').some((item) => item === store);
              if (exist) {
                if (!finalArray.includes(user)) {
                  finalArray.push(user);
                }
              }
            });
          });
          let storesList = userDetails?.stores?.split(',');
          let filterAR = [];
          storesList.forEach((store) => {
            uniqueArray.forEach((obj) => {
              const { storeInvoice } = obj;
              if (storeInvoice === store) {
                filterAR.push(obj);
              }
            });
          });
          dataProcess(filterAR);
        } else if (userDetails?.role === 'admin') {
          dataProcess(uniqueArray);
        } else if (userDetails?.role === 'employee') {
          let filterAR = [];
          uniqueArray.forEach((obj) => {
            if (obj.user === userDetails?.username) {
              filterAR.push(obj);
            }
          });
          dataProcess(filterAR);
        }
      }
    }

    function dataProcess(uniqueArray) {
      accessoryListAR(uniqueArray);
      const groupedBySpecialist = {};
      const groupedByStore = {};
      uniqueArray.forEach((obj) => {
        const { user, ...rest } = obj;
        if (!groupedBySpecialist[user]) {
          groupedBySpecialist[user] = [rest];
        } else {
          groupedBySpecialist[user].push(rest);
        }
        const { storeInvoice, ...rest1 } = obj;
        if (!groupedByStore[storeInvoice]) {
          groupedByStore[storeInvoice] = [rest1];
        } else {
          groupedByStore[storeInvoice].push(rest1);
        }
      });
      function getMSRP(data) {
        const groupedBySpecialistmerged = {};
        for (let key in data) {
          let hupSum = { sf: 0 };
          let actSum = { sf: 0 };

          data[key].forEach((obj) => {
            const { aaData, connectionType, simNumber } = obj;
            const { msrp, discount } = aaData;
            const sf = msrp - discount;
            // Based on Values being reversed
            // const { cost, discount } = aaData;
            // const sf = cost - discount;
            // TO DO: check Reqs doc for the related scenarios and formulas

            if (
              (connectionType === 'Postpaid' || connectionType === 'Prepaid') &&
              simNumber === 'N/A'
            ) {
              hupSum.sf += sf;
            } else if (
              (connectionType === 'Postpaid' || connectionType === 'Prepaid') &&
              simNumber !== 'N/A'
            ) {
              actSum.sf += sf;
            }
          });
          groupedBySpecialistmerged[key] = {
            msrp: actSum.sf + hupSum.sf,
          };
        }
        return groupedBySpecialistmerged;
      }

      let groupedBySpecialistwithstore = {};
      for (let key in groupedBySpecialist) {
        const empbystore = groupedBySpecialist[key]?.reduce((result, item) => {
          const { storeInvoice } = item;
          if (!result[storeInvoice]) {
            result[storeInvoice] = [];
          }
          result[storeInvoice].push(item);
          return result;
        }, {});
        groupedBySpecialistwithstore[key] = getMSRP(empbystore);
      }

      const empData = getMSRP(groupedBySpecialist);
      const storeData = getMSRP(groupedByStore);
      AAMSRP([storeData, empData, groupedBySpecialistwithstore]);
    }

    function dataProcessOA(filtered) {
      accessoryListOA(filtered);
      let oAEmpList = {};
      let oAStoreList = {};
      filtered.forEach((obj) => {
        const { username, ...rest } = obj;

        if (!oAEmpList[username]) {
          oAEmpList[username] = [rest];
        } else {
          oAEmpList[username].push(rest);
        }
      });
      filtered.forEach((obj) => {
        const { saleInvoiceOA, ...rest } = obj;
        const storeInvoice = saleInvoiceOA.slice(0, 7);
        if (!oAStoreList[storeInvoice]) {
          oAStoreList[storeInvoice] = [rest];
        } else {
          oAStoreList[storeInvoice].push(rest);
        }
      });

      let groupedBySpecialistwithstore = {};
      for (let key in oAStoreList) {
        const empbystore = oAStoreList[key].reduce((result, item) => {
          // Get the storeInvoice value
          const { username } = item;

          // Check if the group already exists, if not create an empty array for the group
          if (!result[username]) {
            result[username] = [];
          }

          // Push the current item to the group
          result[username].push(item);

          return result;
        }, {});
        groupedBySpecialistwithstore[key] = getMSRP(empbystore);
      }
      function getMSRP(data) {
        const groupedByAccmerged = {};
        for (let key in data) {
          let accSum = { sf: 0 };
          data[key].forEach((obj) => {
            const { aaDataOnlyAccessory } = obj;
            const { msrp: msrpOA, discount: discountOA } = aaDataOnlyAccessory;
            const sf = msrpOA - discountOA;
            accSum.sf += sf;
          });
          groupedByAccmerged[key] = {
            OAMsrp: accSum.sf,
          };
        }
        return groupedByAccmerged;
      }
      const empMSRP = getMSRP(oAEmpList);
      const storeMSRP = getMSRP(oAStoreList);
      OAMSRP([empMSRP, storeMSRP, groupedBySpecialistwithstore]);
    }

    fetchData();

    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <div className="filter-datemenu">
      <label htmlFor="startDate">From:</label>
      <input
        type="date"
        id="startDate"
        className="filter-datemenu-input"
        name="startDate"
        value={startDate}
        min={'2023-09-01'}
        max={endDate}
        onChange={(e) => {
          const value = e.target.value;
          if (!value) {
           setStartDate(firstDayOfMonthString); // fallback to default
          } else {
            setStartDate(value);
          }

        }}
      />

      <label htmlFor="endDate">To:</label>
      <input
        type="date"
        id="endDate"
        name="endDate"
        className="filter-datemenu-input"
        value={endDate}
        min={startDate}
        max={currentDateString}
        onChange={(e) => {
          const value = e.target.value;
          if (!value) {
             setEndDate(currentDateString); // fallback to default
          } else {
            setEndDate(value);
          }
        }}
      />
    </div>
  );
}

export default DateFilter;
